import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { setMessage } from '../redux/message';
import { Alert } from '@material-ui/lab';

const AppMessage = () => {
  const messageText = useSelector((state) => state.message?.message);
  const severity = useSelector((state) => state.message?.severity);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (messageText) {
      setOpen(true);
    }
  }, [messageText]);

  const handleClose = (event, reason) => {
    dispatch(setMessage('', ''));
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  if (!messageText) {
    return '';
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      message={messageText}
      action={
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      }
    >
      <Alert
        onClose={handleClose}
        variant="filled"
        severity={severity || 'warning'}
      >
        {messageText}
      </Alert>
    </Snackbar>
  );
};

export default AppMessage;
